import { fork } from 'redux-saga/effects';
import { fieldsConfigWatcher } from './fieldsConfigSagas';
import { profileFieldsConfigWatcher } from './profileFieldsConfigSagas';
import { feedbackConfigWatcher } from './feedbackConfigSaga';

export default function* Filters() {
  yield fork(fieldsConfigWatcher);
  yield fork(profileFieldsConfigWatcher);
  yield fork(feedbackConfigWatcher);
}
